<template>
    <div class="item-wrap">
        <div v-for="i in data" :key="i.id" class="item" @click="$router.push('/item/'+i.id)">
            <div class="item_body">
                
                <div class="cover" >
                    <div class="bg" >
                        <img :src="i.img" alt="" style="height:100%;width:100%;border-radius:8px;">
                    </div>
                </div>
                <div class="nocover">
                    <div class="item_tit" @click="$router.push('/item/'+i.id)">
                        <p>
                            {{ i[lang] }}
                        </p>
                    </div>
                    <div class="item_div4">
                        <div class="progress-div">
                            <div class="progress-in" :style="'width: '+i.percent+'%;'"></div>
                        </div>
                        <div class="progress-number">{{ i.percent }}%</div>
                    </div>
                
                </div>
            </div>
            <div class="item-des">
                <div class="des-left">
                    <div class="des-left-top">{{ i['vip'+ vipLevel +'_rate'] }}<span>%</span></div>
                    <div class="des-left-btm">{{ $t('utils.dailyIncome') }}</div>
                </div>
                <div class="des-right">
                    <div class="des-right-top">{{ $t('utils.cycle') }}:<span>{{ i.day }} {{ $t('utils.day') }}</span>
                    </div>
                    <div class="des-right-mid">{{ $t('start_at') }}:<span>{{ $t('utils.money') }}{{ i.min }}</span>
                    </div>
                    <!-- <div class="des-right-btm">{{ $t('VIP_level') }}:<span>{{ i.buy_level }}</span></div> -->
                </div>
            </div>
            <div class="item_btn">
                <div class="item-btn-left">{{ $t('utils.scale') }}: {{ $t('utils.money') }}{{ i.total }}</div>
                <button v-if="i.percent<100" type="button" @click="buy(i)">{{ $t('utils.invest') }}</button>
                <button v-if="i.percent>=100" class="item_btn_over" type="button">{{ $t('utils.investOver') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import api from "../interface/index"
export default {
    name: "itemList",
    props: {
        data: Array
    },
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            vipLevel:0,
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            axios.get(api.commonUrl + '/api/user/myUserInfo?token=' + localStorage.getItem('token')).then(result => {
                //console.log(result);
                if(result.data.data.vip)
                {
                   this.vipLevel = result.data.data.level;
                }
                //console.log(this.vipLevel);
            });
        }
    }
}
</script>

<style lang="less" scoped>
.item-wrap {
    width: 95%;
    margin: 15px auto;
}

.item {
    padding: 5px;
    margin: 0 0 10px 0;
    //background: linear-gradient( #FFFCFB, #FFFCFB);
    //background: linear-gradient(#b6b2b1, #868686);
    //background: linear-gradient(#1e1e5c, #696c95);
    background: #2B3864;
    //border: 2px solid #F7F1DF;
    border-radius: 8px;
    
    div {
        margin: 5px 0;
    }
    
    .item_body {
        display: flex;
        margin: 0;
        
        .cover {
            .bg {
                background-size: cover !important;
                height: 60px;
                width: 60px;
            }
            
            //width: auto;
            margin: 0;
            padding: 0 10px;
        }
        
        .nocover {
            width: 75%;
            margin: 0;
        }
    }
    
    .item_tit {
        // text-align: center;
        overflow: hidden;
        height: 35px;
        line-height: 30px;
        color: #ffffff;
        
        p {
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: bold;
            font-size: 0.45rem;
            font-family: Arial-Black;
        }
    }
    
    .item_rate {
        //text-align: center;
        color: #FF0000;
        font-size: 16px;
        font-weight: bold;
    }
    
    .item_desc {
        display: flex;
        
        p {
            width: 50%;
            // text-align: center;
            line-height: 16px;
        }
    }
    
    .item_btn {
        text-align: center;
        //overflow: hidden;
        height: 35px;
        
        button {
            //width: 30%;
            min-width: 100px;
            background: #EEE0C5;
            color: #917A4C;
            padding: 8px 0px;
            border-radius: 10px;
            float: right;
            border: 1px solid #EEE0C5;
            font-weight: 700;
        }
        
    }
}

.item_btn_over {
    //background: #999;
    border: none !important;
    background: #2b2b64 !important;
    color: white !important;
}

.item_div4 {
    position: relative;
}

.progress-number {
    position: absolute;
    color: #947F59;
    left: 72%;
    height: 10px;
    top: -1px;
    margin: 0 !important;
    font-size: 12px;
    font-weight: 700;
    
}

.item-des {
    height: 60px;
    //background: #8d8d8f;
    width: 100%;
    margin: 0 !important;
}

.des-left-btm {
    font-size: 0.4rem;
    color: #AD9D89;
}

.des-left-top {
    height: 30px;
    line-height: 30px;
    color: #E64D20;
    font-size: 0.7rem;
    font-weight: 700;
}

.des-left {
    width: 36%;
    height: 100%;
    //background: #07c160;
    text-align: center;
    float: left;
}

.des-right {
    width: 64%;
    height: 100%;
    //background: #07c160;
    //text-align: left;
    text-indent: 0.5rem;
    float: left;
}

.progress-div {
    width: 70%;
    height: 10px;
    border-radius: 5px;
    background: #E2DCD4;
    position: relative;
}

.progress-in {
    height: 10px;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 0;
    background: #3BA00E;
    width: 50%;
    margin: 0 !important;
}

.des-right {
    width: 64%;
    height: 100%;
    //background: #07c160;
    //text-align: left;
    text-indent: 0.5rem;
    float: left;
}

.des-right-top {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.3rem;
    //font-weight: 700;
    color: #ffffff;
}

.des-right-mid {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.3rem;
    //font-weight: 700;
    //color: #826B47;
    color: #ffffff;
}

.des-right-btm {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.3rem;
    //font-weight: 700;
    //color: #826B47;
    color: #ffffff;
}

.item-btn-left {
    float: left;
    padding: 8px 0;
    font-size: 0.35rem;
    //color: #AA976F;
    color: #a7a3a3;
}
</style>